import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

export function* getCustomerGroupDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.CUSTOMERGROUP_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.CUSTOMERGROUP_DETAILS_FAILURE });
        return error;
    }
}

export function* getPosSetupDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.POS_SETUP_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.POS_SETUP_DETAILS_FAILURE });
        return error;
    }
}

export function* getPosSetupUsers(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.POS_SETUP_USERS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.POS_SETUP_USERS_FAILURE });
        return error;
    }
}

export function* getCustomerProducts(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.CPRODUCT_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.CPRODUCT_DETAILS_FAILURE });
        return error;
    }
}

export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_SALES_SETUP_DETAILS_SUCCESS,
    });
}

export default function* salesManagementSaga() {
    yield all([
        takeEvery(actions.CUSTOMERGROUP_DETAILS_START, getCustomerGroupDetails),
        takeEvery(actions.POS_SETUP_DETAILS_START, getPosSetupDetails),
        takeEvery(actions.POS_SETUP_USERS_START, getPosSetupUsers),
        takeEvery(actions.CPRODUCT_DETAILS_START, getCustomerProducts),
        takeEvery(actions.CLEAR_SALES_SETUP_DETAILS_START, getClearDetails)
    ]);
}